import Container from '@/components/Container';
import Divider from '@/components/Divider';
import ProfileInfo from './info/Info';
import ProfilePassword from './password/Password';
import { useProfileStore } from './store/useProfileStore';
import { useEffect } from 'react';
import { useAuthentication } from '@/hooks/useAuthentication';
import SubContainer from '@/components/Container/SubContainer';
import { ProfileEmotionWheelTrackingCalendar } from '@/pages/profile/EmotionWheelTrackingCalendar';
import { ProfileStreak } from './Streak';

export default function ProfilePage() {
  const { user, onInit, page } = useProfileStore();
  const { authentication } = useAuthentication();

  useEffect(() => {
    onInit(authentication.user.id);
  }, [authentication.user.id, onInit]);

  return (
    <Container addMargin>
      <SubContainer className="flex justify-center ">
        <h1 className=" text-sh-md font-bold">
          {page.welcomeTitle} {user?.attributes?.forename} {user?.attributes?.surname}
        </h1>
      </SubContainer>
      <SubContainer className="md:mb-16">
        <Divider />
      </SubContainer>
      <ProfileInfo />
      <ProfileStreak />
      <ProfileEmotionWheelTrackingCalendar />
      <ProfilePassword />
    </Container>
  );
}
